import React from "react";
import { Edit } from "lucide-react";

export default function CuponesTableComponent({
  data = [],
  metaPaginacion = {},
  onPageChange,
  perPage = 10,
  onPerPageChange,
  handleEditarItem,
  handleOpenModalDeleteEvento
}) {
  return (
    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
      {/* Header de la tabla */}
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50 border-b border-gray-200">
            <tr>
              <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Cliente
              </th>
              <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Cedula
              </th>
              <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Sorteo
              </th>
              {/* <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Fecha (factura)
              </th> */}
              <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Fecha (procesamiento)
              </th>
              {/* <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Fecha (creacion de factura)
              </th> */}
              <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Nro. de la factura
              </th>
              <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Local
              </th>
              <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Monto
              </th>
              <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Total de cupones
              </th>
              <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Cupones anulados
              </th>
              <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Procesado por
              </th>
              <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Acciones
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {data?.map((item, index) => (
              <tr key={index} className="hover:bg-gray-50 transition-colors">
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="font-medium text-gray-900 max-w-[100px] truncate">{item?.cliente || '-'}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-gray-700 max-w-[100px] truncate">{item?.ci || '-'}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div
                    // className="text-sm text-gray-700"
                    className="font-medium text-gray-700 max-w-[100px] truncate"
                  >
                    {item?.sorteo || '-'}
                  </div>
                </td>
                {/* <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-gray-700 max-w-[100px] truncate">{item?.fecha_factura || '-'}</div>
                </td> */}
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-gray-700 max-w-[100px] truncate">{item?.fecha_procesamiento || '-'}</div>
                </td>
                {/* <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-gray-700 max-w-[100px] truncate">{item?.fecha_creacion_factura || '-'}</div>
                </td> */}
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-gray-700 max-w-[100px] truncate">{item?.nro_factura || '-'}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-gray-700 max-w-[100px] truncate">{item?.local || '-'}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-gray-700 max-w-[100px] truncate">{item?.monto || '-'}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-gray-700 max-w-[100px] truncate">{item?.cupones || '-'}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-gray-700 max-w-[100px] truncate">{item?.anulado || '-'}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-gray-700 max-w-[100px] truncate">{item?.procesado_por || '-'}</div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center gap-2">
                    <button
                      className="p-1 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer"
                      title="Editar"
                      onClick={() => handleEditarItem(item)}
                    >
                      <Edit className="w-4 h-4 text-gray-500" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Si no hay datos */}
      {data.length === 0 && (
        <div className="text-center py-12">
          <div className="text-gray-500">
            No hay cupones para mostrar.
          </div>
        </div>
      )}

      {/* Paginación */}
      {metaPaginacion && metaPaginacion.total > 0 && (
        <div className="px-6 py-4 border-t border-gray-200 bg-gray-50">
          <div className="flex items-center justify-between">
            {/* Info de página e índice */}
            <div className="flex items-center gap-4">
              <div className="text-sm text-gray-700">
                Mostrando <span className="font-medium">{((metaPaginacion.current_page - 1) * metaPaginacion.per_page) + 1}</span> a{" "}
                <span className="font-medium">
                  {Math.min(metaPaginacion.current_page * metaPaginacion.per_page, metaPaginacion.total)}
                </span> de{" "}
                <span className="font-medium">{metaPaginacion.total}</span> cupones
              </div>

              {/* Selector de cantidad por página */}
              <div className="flex items-center gap-2">
                <span className="text-sm text-gray-600">Mostrar:</span>
                <select
                  value={perPage}
                  onChange={(e) => onPerPageChange && onPerPageChange(Number(e.target.value))}
                  className="border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={15}>15</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </select>
                <span className="text-sm text-gray-600">por página</span>
              </div>
            </div>

            {/* Índice de páginas y navegación */}
            <div className="flex items-center gap-4">
              {/* Índice de páginas */}
              <div className="text-sm text-gray-700">
                Página <span className="font-medium">{metaPaginacion.current_page}</span> de{" "}
                <span className="font-medium">{metaPaginacion.last_page}</span>
              </div>

              {/* Botones de navegación */}
              <div className="flex items-center gap-2">
                <button
                  onClick={() => onPageChange && onPageChange(1)}
                  disabled={metaPaginacion.current_page === 1}
                  className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Primera
                </button>
                <button
                  onClick={() => onPageChange && onPageChange(metaPaginacion.current_page - 1)}
                  disabled={metaPaginacion.current_page === 1}
                  className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Anterior
                </button>
                <button
                  onClick={() => onPageChange && onPageChange(metaPaginacion.current_page + 1)}
                  disabled={metaPaginacion.current_page === metaPaginacion.last_page}
                  className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Siguiente
                </button>
                <button
                  onClick={() => onPageChange && onPageChange(metaPaginacion.last_page)}
                  disabled={metaPaginacion.current_page === metaPaginacion.last_page}
                  className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Última
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}